const initialState = {
    calls: {},
    isReadingCalls: false,
    isHangingUp: false,
    
    incomingCalls: [],
    recentCalls: [],
    numberOfConferenceRooms: 0,
    departments: [],
    extensions: {},
    queues: [],
    callerInActionsView: null,
    actionsViewVisible: false,
    isActiveCall: false,

    selectedTeamsTab: "pinned",
    currentCall: null,
    isReadingCreds: false,
    creds: {},
    callState: 'idle',
    contactLeg: null, 
    userLeg: null,
    currentPBX: null,
    pbx: null,
    endedCalls: {},
    currentCallPhoneNumber: null,
    callDirection: null,
    isIgnore: false,
    selectedTab: 0,
    islookingupUser: false,
    dialerContactLookup: null,

    // The uuid of the agent dialing
    dialer: null,
    // {campaign_id, campaign_name, agent_uuid, call_uuid, contact_id, redirect}
}

export default initialState;
